import Case from '@/entities/case/case';

export function getCasesResponse(data) {
  return data.data.map((item) => new Case(item));
}

export function getCaseByIdResponse(data) {
  return new Case(data.data);
}



// WEBPACK FOOTER //
// src/services/cases/response.js